import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, TextLink } from '@modusign/design-system';
import { MouseEventHandler, ReactNode } from 'react';

interface IconLinkButtonProps {
  children: ReactNode;
  icon: IconDefinition;
  onClick: MouseEventHandler<HTMLAnchorElement>;
}

export default function IconLinkButton({ children, icon, onClick }: IconLinkButtonProps) {
  return (
    <TextLink color="textNeutralLight" display="flex" fontSize="md" onClick={onClick}>
      <Flex alignItems="center" fontSize="12px">
        <FontAwesomeIcon icon={icon} />
      </Flex>
      {children}
    </TextLink>
  );
}
